import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import p from "./panelHeader.js";
import { useDualCalendarProps as _, useDualCalendar as k } from "./use-dual-calendar.js";
import { warnOnce as y } from "../../../_utils/naive/warn.js";
import D from "../../../_internal/focus-detector/src/FocusDetector.js";
import u, { XButton as x } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as v, resolveSlot as r } from "../../../_utils/vue/resolve-slot.js";
import f from "../../../_internal/icons/FastBackward.js";
import C from "../../../_internal/icons/Backward.js";
import m from "../../../_internal/icons/Forward.js";
import $ from "../../../_internal/icons/FastForward.js";
import { defineComponent as g, watchEffect as M, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const V = g({
  name: "DateRangePanel",
  props: _,
  setup(s) {
    return process.env.NODE_ENV !== "production" && M(() => {
      var d;
      !((d = s.actions) === null || d === void 0) && d.includes("now") && y("date-picker", "The `now` action is not supported for n-date-picker of `daterange` type");
    }), k(s, "daterange");
  },
  render() {
    var s, d, c;
    const {
      mergedClsPrefix: e,
      mergedTheme: i,
      shortcuts: o,
      onRender: h,
      datePickerSlots: n
    } = this;
    return h == null || h(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--daterange`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      ref: "startDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--start`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, r(n["prev-year"], () => [a(f, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, r(n["prev-month"], () => [a(C, null)])), a(p, {
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, r(n["next-month"], () => [a(m, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, r(n["next-year"], () => [a($, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.startDateArray.map((t, l) => a("div", {
      "data-n-date": !0,
      key: l,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
        [`${e}-date-panel-date--current`]: t.isCurrentDate,
        [`${e}-date-panel-date--selected`]: t.selected,
        [`${e}-date-panel-date--covered`]: t.inSpan,
        [`${e}-date-panel-date--start`]: t.startOfSpan,
        [`${e}-date-panel-date--end`]: t.endOfSpan,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t.ts)
      }],
      onClick: () => {
        this.handleDateClick(t);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t);
      }
    }, a("div", {
      class: `${e}-date-panel-date__trigger`
    }), t.dateObject.date, t.isCurrentDate ? a("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), a("div", {
      class: `${e}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--end`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, r(n["prev-year"], () => [a(f, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, r(n["prev-month"], () => [a(C, null)])), a(p, {
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, r(n["next-month"], () => [a(m, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, r(n["next-year"], () => [a($, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.endDateArray.map((t, l) => a("div", {
      "data-n-date": !0,
      key: l,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
        [`${e}-date-panel-date--current`]: t.isCurrentDate,
        [`${e}-date-panel-date--selected`]: t.selected,
        [`${e}-date-panel-date--covered`]: t.inSpan,
        [`${e}-date-panel-date--start`]: t.startOfSpan,
        [`${e}-date-panel-date--end`]: t.endOfSpan,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t.ts)
      }],
      onClick: () => {
        this.handleDateClick(t);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t);
      }
    }, a("div", {
      class: `${e}-date-panel-date__trigger`
    }), t.dateObject.date, t.isCurrentDate ? a("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? a("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((s = this.actions) === null || s === void 0) && s.length || o ? a("div", {
      class: `${e}-date-panel-actions`
    }, a("div", {
      class: `${e}-date-panel-actions__prefix`
    }, o && Object.keys(o).map((t) => {
      const l = o[t];
      return Array.isArray(l) || typeof l == "function" ? a(x, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(l);
        },
        onClick: () => {
          this.handleRangeShortcutClick(l);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t
      }) : null;
    })), a("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((d = this.actions) === null || d === void 0) && d.includes("clear") ? v(n.clear, {
      onClear: this.handleClearClick,
      text: this.locale.clear
    }, () => [a(u, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    })]) : null, !((c = this.actions) === null || c === void 0) && c.includes("confirm") ? v(n.confirm, {
      onConfirm: this.handleConfirmClick,
      disabled: this.isRangeInvalid || this.isSelecting,
      text: this.locale.confirm
    }, () => [a(u, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    })]) : null)) : null, a(D, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/daterange.js
// module id = 1625
// module chunks = 41